/**
 * engagementcommentreducer.js
 * Created by yonamine on 05/11/2020.
 */
import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {EngagementCommentStatusIds, EngagementCommentStatus} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import _ from 'lodash';

export default function engagementCommentReducer(state = initialstate.engagementComments, action) {
	switch (action.type) {
		case actions.SET_ENGAGEMENT_COMMENTS_CONFIG_DATA:
			if (action) {
				return {
					...state,
					config: action.config
				};
			}
			break;
		case actions.CLEAR_ENGAGEMENT_COMMENTS:
			return clearEngagementComments(action.entityUid, state);
		case actions.SET_SELECTED_ENGAGEMENT_COMMENT_GUID:
			if (action) {
				return setSelectedEngagementCommentGuid(state, action.guid);
			}
			break;
		case actions.GET_ALL_ENGAGEMENT_COMMENTS:
			if (action.response) {
				return applyResponse(state, action);
			}
			return state;
		case actions.SET_ENGAGEMENT_COMMENTS_FILTER:
			if (action) {
				return addFilterToEngagementComments(state, action.filter);
			}
			return state;
		case actions.REMOVE_ENGAGEMENT_COMMENTS_FILTER:
			if (action) {
				return removeFilterFromEngagementComments(state, action.filterType);
			}
			return state;
		case actions.DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL:
			if (action) {
				return setEngagementCommentInputModalData(state, action.modalConfig);
			}
			return state;
		case actions.CREATE_ENGAGEMENT_COMMENT:
			if (action.response && !action.error) {
				let _state = {...state};
				let newGroupId = action.response.engagementCommentGuid;
				let newOpenGroup = createGroupForComment(action.response, newGroupId);
				let open = state.open
					? {
							...state.open,
							byId: {...state.open.byId, [newGroupId]: newOpenGroup},
							allIds: [...state.open.allIds, newGroupId]
					  }
					: Utility.normalize(newOpenGroup, state.open, 'id');

				if (action.response.entityUid) {
					let entityUid = action.response.entityUid;
					let entityUidsComments = [];
					if (!state[entityUid]) {
						entityUidsComments = [action.response];
					} else {
						entityUidsComments = [...state[entityUid], action.response];
					}
					_state = {
						...state,
						open: open,
						[entityUid]: entityUidsComments
					};
				} else {
					_state = {
						...state,
						open: open
					};
				}

				return _state;
			}
			return state;
		case actions.CREATE_ENGAGEMENT_COMMENT_REPLY:
			if (action.response) {
				let group = getCommentGroup(state, action.response.parentEngagementCommentGuid);
				let status = EngagementCommentStatusIds[group.byId[group.allIds[0]].engagementCommentStatusId];

				return {
					...state,
					[status]: {
						...state[status],
						byId: {
							...state[status].byId,
							[group.id]: {
								...state[status].byId[group.id],
								byId: {
									...state[status].byId[group.id].byId,
									[action.response.engagementCommentGuid]: action.response,
									[action.response.parentEngagementCommentGuid]: {
										...state[status].byId[group.id].byId[action.response.parentEngagementCommentGuid],
										modifyDate: action.response.createDate
									}
								},
								allIds: [...state[status].byId[group.id].allIds, action.response.engagementCommentGuid]
							}
						}
					}
				};
			}
			break;
		case actions.UPDATE_ENGAGEMENT_COMMENT:
			if (action.response) {
				let commentGuid = action.response.parentEngagementCommentGuid
					? action.response.parentEngagementCommentGuid
					: action.response.engagementCommentGuid;

				let group = getCommentGroup(state, commentGuid);

				let engagementCommentStatusId = action.response.parentEngagementCommentGuid
					? group.byId[group.allIds[0]].engagementCommentStatusId
					: action.response.engagementCommentStatusId;

				let status = EngagementCommentStatusIds[engagementCommentStatusId];

				return {
					...state,
					[status]: {
						...state[status],
						byId: {
							...state[status].byId,
							[group.id]: {
								...state[status].byId[group.id],
								byId: {
									...state[status].byId[group.id].byId,
									[action.response.engagementCommentGuid]: action.response
								}
							}
						}
					}
				};
			}
			break;
		case actions.UPDATE_ENGAGEMENT_COMMENT_STATUS:
			if (action.response) {
				let commentGuid = action.response.parentEngagementCommentGuid
					? action.response.parentEngagementCommentGuid
					: action.response.engagementCommentGuid;
				let newStatus = EngagementCommentStatusIds[action.response.engagementCommentStatusId];
				let group = getCommentGroup(state, commentGuid);

				group = {
					...group,
					byId: {
						...group.byId,
						[action.response.engagementCommentGuid]: action.response
					}
				};

				let partialState = removeGroupFromPreviousStatusSection(state, group);

				let section = partialState[newStatus]
					? {
							...partialState[newStatus],
							byId: {...partialState[newStatus].byId, [group.id]: group},
							allIds: [...partialState[newStatus].allIds, group.id]
					  }
					: Utility.normalize(group, partialState[newStatus], 'id');

				let entityUid = action.response.entityUid;
				let entityUidsComments = [];
				if (state[entityUid]) {
					entityUidsComments = [...state[entityUid]];
					let found = entityUidsComments.findIndex(
						(c) => c.engagementCommentGuid === action.response.engagementCommentGuid
					);
					if (found >= 0) {
						let update = {...entityUidsComments[found]};
						update.engagementCommentStatusId = action.response.engagementCommentStatusId;
						entityUidsComments[found] = update;
					}
				}
				return {
					...partialState,
					[entityUid]: entityUidsComments,
					[newStatus]: section
				};
			}
			break;
		case actions.DELETE_ENGAGEMENT_COMMENT_PARENT:
			if (!action.error) {
				let group = getCommentGroup(state, action.parentEngagementCommentGuid);
				let entityUid = action.entityUid;
				let entityUidsComments = [];
				if (state[entityUid]) {
					entityUidsComments = [...state[entityUid]];
					let found = entityUidsComments.findIndex((c) => c.engagementCommentGuid === action.engagementCommentGuid);
					if (found > -1) {
						entityUidsComments.splice(found, 1);
					}
				}
				let _state = {...state};
				_state = {
					...state,
					[entityUid]: entityUidsComments
				};
				return removeGroupFromPreviousStatusSection(_state, group);
			}
			break;
		case actions.DELETE_ENGAGEMENT_COMMENT_CHILD:
			if (!action.error) {
				let group = getCommentGroup(state, action.parentEngagementCommentGuid);

				return removeReplyFromGroup(state, group, action.engagementCommentGuid);
			}
			break;
		case actions.UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS:
			if (action.bodyIds) {
				let _state = _.cloneDeep(state);
				action.bodyIds.map((bodyId) => {
					if (_state[bodyId]) {
						let comments = _state[bodyId];
						if (comments) {
							comments.map((c) => {
								c.engagementCommentStatusId = EngagementCommentStatus.closed;
							});
						}
					}
				});
				return _state;
			}
			break;
		case actions.ADD_TO_ENGAGEMENT_COMMENT_SLICE:
			if (action.comment) {
				return applyResponse(state, action);
			}
			return state;
		default:
			return state;
	}
}

function applyResponse(state, action) {
	let _state = {...state};
	let response;
	switch (action.type) {
		case actions.ADD_TO_ENGAGEMENT_COMMENT_SLICE:
			if (action.comment) {
				response = action.comment;
				if (response.length > 0) {
					_state = {
						..._state,
						[response[0].entityUid || response[0].id]: response
					};
				}
			}
			return _state;
		case actions.GET_ALL_ENGAGEMENT_COMMENTS:
			if (action.response) {
				response = action.response;
				_state = {
					..._state,
					[EngagementCommentStatusIds[EngagementCommentStatus.open]]: {byId: {}, allIds: []},
					[EngagementCommentStatusIds[EngagementCommentStatus.cleared]]: {byId: {}, allIds: []},
					[EngagementCommentStatusIds[EngagementCommentStatus.closed]]: {byId: {}, allIds: []}
				};

				let commentStatuses;

				let allStatus = [
					EngagementCommentStatusIds[EngagementCommentStatus.open],
					EngagementCommentStatusIds[EngagementCommentStatus.cleared],
					EngagementCommentStatusIds[EngagementCommentStatus.closed]
				];

				for (let i = 0; i < allStatus.length; i++) {
					let section;
					let _status = allStatus[i];
					let _comments = response.filter((comment) => {
						return EngagementCommentStatusIds[comment.engagementCommentStatusId] === _status;
					});

					for (let j = 0; j < _comments.length; j++) {
						let engagementComment = _comments[j];

						populateDefaultValues(engagementComment);

						const group = createGroupForComment(engagementComment);

						section = Utility.normalize(group, section);
						commentStatuses = Utility.normalize(
							{
								engagementCommentGuid: engagementComment.engagementCommentGuid,
								statusLabel: EngagementCommentStatusIds[engagementComment.engagementCommentStatusId],
								statusId: engagementComment.engagementCommentStatusId
							},
							commentStatuses,
							'engagementCommentGuid'
						);
					}

					_state = {
						..._state,
						[_status]: section || _state[_status],
						commentStatuses: commentStatuses
					};
				}
				if (response.length > 0) {
					_state = {
						..._state,
						[response[0].entityUid || response[0].id]: response
					};
				}
			}
			return _state;
	}
	return _state;
}

//Here we handle values needed to be set up which were not populated with a post deployment script.
function populateDefaultValues(comment) {
	if (!comment.dueDate) {
		comment.dueDate = new Date();
	}
}

function setEngagementCommentInputModalData(state, modalConfig) {
	let _state = {...state};

	_state = {
		...state,
		modalConfig: modalConfig
	};

	return _state;
}

function clearEngagementComments(entityUid, state) {
	let _state = {
		...state,
		open: undefined,
		cleared: undefined,
		closed: undefined,
		config: {},
		filters: undefined,
		selectedCommentGuid: undefined
	};

	return _state;
}

function addFilterToEngagementComments(state, filter) {
	let _state;

	if (state.filters && state.filters.allIds.length > 0) {
		if (state.filters.allIds.indexOf(filter.filterType) > -1) {
			_state = {
				...state,
				filters: {
					...state.filters,
					byId: {
						...state.filters.byId,
						[filter.filterType]: filter
					}
				}
			};
		} else {
			_state = {
				...state,
				filters: {
					...state.filters,
					byId: {...state.filters.byId, [filter.filterType]: filter},
					allIds: [...state.filters.allIds, filter.filterType]
				}
			};
		}
	} else {
		_state = {
			...state,
			filters: Utility.normalize(filter, state.filters, 'filterType')
		};
	}

	return _state;
}

function removeFilterFromEngagementComments(state, filterType) {
	if (state.filters && state.filters.allIds.indexOf(filterType) > -1) {
		let filters = [];

		for (let i = 0; i < state.filters.allIds.length; i++) {
			let _filterType = state.filters.allIds[i];

			if (_filterType !== filterType) {
				filters.push(state.filters.byId[_filterType]);
			}
		}

		//We keep the rest of the filters.
		if (filters.length > 0) {
			return {
				...state,
				filters: Utility.normalize(filters, undefined, 'filterType')
			};
		} else {
			//There is no filter to apply to the chart.
			return {
				...state,
				filters: undefined
			};
		}
	}

	return state;
}

function setSelectedEngagementCommentGuid(state, guid) {
	let _state = {
		...state,
		selectedCommentGuid: guid
	};

	return _state;
}

//Will create a new group { id: number, byId: {}, allIds: []} for a new parent comment
function createGroupForComment(engagementComment) {
	let group;

	group = Utility.normalize(engagementComment, group, 'engagementCommentGuid');

	if (engagementComment.replies && engagementComment.replies.length > 0) {
		for (let j = 0; j < engagementComment.replies.length; j++) {
			const childEngagementComment = engagementComment.replies[j];

			group = Utility.normalize(childEngagementComment, group, 'engagementCommentGuid');
		}
	}

	group['id'] = engagementComment.engagementCommentGuid;

	return group;
}

//This will give you the Group { id: number, byId: {}, allIds: []} which holds the comment.
function getCommentGroup(engagementComments, commentGuid) {
	let allStatus = [EngagementCommentStatusIds[1], EngagementCommentStatusIds[2], EngagementCommentStatusIds[3]];
	let byId = {};
	let allIds = [];
	let group;

	for (let j = 0; j < allStatus.length; j++) {
		if (engagementComments[allStatus[j]]) {
			byId = engagementComments[allStatus[j]].byId;
			allIds = engagementComments[allStatus[j]].allIds;

			for (let i = 0; i < allIds.length; i++) {
				group = byId[allIds[i]];

				let index = group.allIds.indexOf(commentGuid);

				if (index > -1) {
					return group;
				}
			}
		}
	}

	return undefined;
}

function removeReplyFromGroup(state, group, engagementCommentGuid) {
	let alteredGroup;
	let section = EngagementCommentStatusIds[group.byId[group.allIds[0]].engagementCommentStatusId];

	for (let i = 0; i < group.allIds.length; i++) {
		let guid = group.allIds[i];
		let engagementComment = group.byId[guid];

		if (engagementComment.engagementCommentGuid !== engagementCommentGuid) {
			alteredGroup = Utility.normalize(engagementComment, alteredGroup, 'engagementCommentGuid');
		}
	}

	alteredGroup['id'] = group.id;

	return {
		...state,
		[section]: {
			...state[section],
			byId: {
				...state[section].byId,
				[group.id]: alteredGroup
			}
		}
	};
}

//Will remove the group from its previous status section.
function removeGroupFromPreviousStatusSection(engagementComments, group) {
	let previousStatus = '';
	let allStatus = [EngagementCommentStatusIds[1], EngagementCommentStatusIds[2], EngagementCommentStatusIds[3]];
	let comments = [];

	for (let i = 0; i < allStatus.length; i++) {
		previousStatus = allStatus[i];

		if (engagementComments[previousStatus] && engagementComments[previousStatus].allIds.indexOf(group.id) > -1) {
			break;
		}
	}

	for (let i = 0; i < engagementComments[previousStatus].allIds.length; i++) {
		let groupId = engagementComments[previousStatus].allIds[i];

		if (groupId !== group.id) {
			comments.push(engagementComments[previousStatus].byId[groupId]);
		}
	}

	return {
		...engagementComments,
		[previousStatus]: Utility.normalize(comments, undefined, 'id')
	};
}
